import React from "react";
import "../../pages/event/events.css";
import { Link, useParams } from "react-router-dom";
import moment from "moment-timezone";
import { Box, Container, Grid } from "@mui/material";
import { useIndividualNews } from "./customHook";

function IndividualNews() {
  const { slug } = useParams();
  const { event, loading } = useIndividualNews(slug);

  if (loading) return <p className="text-center my-5">Loading...</p>;

  return (
    <>
      <Container maxWidth="xl" className="page-header py-4 breadcrumb-bg">
        <h1 className="text-center display-6 breadcrumb-h1">Latest News</h1>
        <ul className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active">News</li>
        </ul>
      </Container>

      <Container className="py-5">
        <Grid className="text-center mb-5">
          <h1 className="mb-3">
            <span className="text-secundary">{event?.title}</span>
          </h1>
        </Grid>

        <Grid container spacing={1}>
          <Grid item lg={8} md={8}>
            <Grid display="flex" justifyContent="space-between" className="mb-4">
              <Grid className="p-2 timep">
                Starting Date :{" "}
                <span>
                  {moment(event?.date).tz("America/New_York").format("MM / DD / YY")}
                </span>
              </Grid>
            </Grid>

            <h3 className="ttl-h2">{event?.title || "BalGokul"}</h3>
            <p dangerouslySetInnerHTML={{ __html: event?.description }} />
          </Grid>

          <Grid item lg={4} md={4}>
            <img
              className="balgokul-img img-res"
              src={event?.image}
              alt={event?.title || "balgokul"}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default IndividualNews;
